import { AssignedCharacter } from "../../api"

export interface FactoryHp {
  current: number
  max: number
}

export interface MiningGem {
  gemItem: string | null // Only "sunshard-prosper" is allowed
  assignedAt: string | null
}


export interface MiningFactory {
  _id: string
  walletAddress: string
  factoryType: number
  level: number
  hp: FactoryHp
  miningGem: MiningGem
  isMining: boolean
  miningStartedAt: string | null
  lastMiningUpdate: string | null
  totalMined: number
  pendingMinedUsdt: number
  lastMiningDate: string | null
  assignedCharacters: AssignedCharacter[]
  createdAt: string
  updatedAt: string
  dailyMiningRateUsdt: number
}

export interface WeatherForecast {
  _id: string
  walletAddress: string
  level: number
  hp: FactoryHp
  unlocked: boolean
  assignedCharacter?: {
    characterInstanceId: AssignedCharacter['characterInstanceId'] | null
    assignedAt: string | null
  }
  equippedGems?: Array<{
    gemType: string
    itemId: string
    equippedAt: string
  }>
  detectedWeather?: string
  nextDisaster?: {
    type: string
    scheduledTime: string
    damageAmount: number
  }
  createdAt?: string
  updatedAt?: string
}

export interface MiningFactoryState {
  isLoading: boolean
  isLoadingFactoryDetails: boolean // Loading state for fetching factory by ID
  error?: string
  // Legacy fields for backward compatibility
  factoryLevels: Record<number, number> // factoryType -> level (0 = weather forecast, 1-4 = factories)
  factoryHp: Record<number, FactoryHp> // factoryType -> { current, max } (0 = weather forecast, 1-4 = factories)
  isWeatherForecastUnlocked: boolean
  // New fields for complete factory data
  factories: Record<number, MiningFactory | null> // factoryType -> full factory object (1-4 = factories)
  weatherForecast: WeatherForecast | null // Weather Observatory data
  // Factory details by ID (for modals)
  factoryDetails: Record<string, MiningFactory | null> // factoryId -> full factory object
  selectedFactoryId: string | null // Currently selected factory ID for modal
}

// Calculate max HP for weather forecast (baseHp = 100, hpPerLevel = 25)
const getWeatherForecastMaxHp = (level: number) => 100 + (level - 1) * 25

export const initialMiningFactoryState: MiningFactoryState = {
  isLoading: false,
  isLoadingFactoryDetails: false,
  error: undefined,
  factoryLevels: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 }, // 0 = weather forecast
  factoryHp: {
    0: { current: 0, max: getWeatherForecastMaxHp(1) }, // Weather Forecast
    1: { current: 0, max: 100 },
    2: { current: 0, max: 100 },
    3: { current: 0, max: 100 },
    4: { current: 0, max: 100 },
  },
  isWeatherForecastUnlocked: false,
  factories: {
    1: null,
    2: null,
    3: null,
    4: null,
  },
  weatherForecast: null,
  factoryDetails: {},
  selectedFactoryId: null,
}
